export class PucaUndertakingModel{
	hasDisability: string = "0";
	shareInfo: string = "0";
	rpText: string = 'Characters Remaining: 2000';
	sopText: string = 'Characters Remaining: 2000';
	ResearchProposal: string = '';
	StatementOfPurpose: string = '';
	UndertakingAccepted: boolean = false;
	disabilityDetails: string = "";
}
